import React from 'react'

const StepCard = ({ number, title, description }) => {
  return (
    <div className='flex flex-col items-center text-center'>
      <div className='flex items-center justify-center w-10 h-10 rounded-full bg-primary text-text-primary font-bold mb-4'>
        {number}
      </div>
      <h3 className='text-lg font-bold text-text-primary mb-2'>{title}</h3>
      <p className='text-text-secondary text-base'>{description}</p>
    </div>
  )
}

export default StepCard
